"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeOrCadLogicalSchematicPath = normalizeOrCadLogicalSchematicPath;
exports.resolveOrCadLogicalSchematicReference = resolveOrCadLogicalSchematicReference;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
function normalizeSeparators(path) {
    return path.replace(/\\/g, '/');
}
function normalizeOrCadLogicalSchematicPath(path) {
    return normalizeSeparators(sigma_engine_shared_1.Files.resolvePath('.', normalizeSeparators(path))).toLowerCase();
}
function canonicalSchematicStem(path) {
    return normalizeOrCadLogicalSchematicPath(path).replace(/\.(dsn|xml)$/i, '');
}
function isAbsoluteOrCadPath(path) {
    return path.startsWith('/') || path.startsWith('//') || /^[a-z]:\//i.test(path);
}
function normalizeReference(referencingFile, reference) {
    const normalizedReference = normalizeSeparators(reference);
    const allowSuffixMatch = isAbsoluteOrCadPath(normalizedReference);
    const baseDirectory = normalizeSeparators(sigma_engine_shared_1.Files.dirnamePath(normalizeSeparators(referencingFile)));
    const path = normalizeSeparators(sigma_engine_shared_1.Files.resolvePath(allowSuffixMatch ? '' : baseDirectory, normalizedReference)).toLowerCase();
    return {
        path,
        stem: path.replace(/\.(dsn|xml)$/i, ''),
        allowSuffixMatch,
    };
}
function candidatePreference(sourceFile) {
    if (/\.dsn$/i.test(sourceFile)) {
        return 2;
    }
    if (/\.xml$/i.test(sourceFile)) {
        return 1;
    }
    return 0;
}
function groupedCandidates(candidates, referencingFile) {
    const referencingStem = canonicalSchematicStem(referencingFile);
    const grouped = new Map();
    for (const candidate of candidates) {
        const stem = canonicalSchematicStem(candidate.sourceFile);
        if (stem === referencingStem) {
            continue;
        }
        const selected = grouped.get(stem);
        if (!selected || candidatePreference(candidate.sourceFile) > candidatePreference(selected.sourceFile)) {
            grouped.set(stem, candidate);
        }
    }
    return Array.from(grouped, ([stem, candidate]) => ({ stem, candidate })).sort((a, b) => a.stem.localeCompare(b.stem));
}
function resolutionFromMatches(matches, normalizedPath, matchKind) {
    if (matches.length === 1) {
        return { status: 'resolved', candidate: matches[0].candidate, matchKind, normalizedPath };
    }
    if (matches.length > 1) {
        return {
            status: 'unresolved',
            reason: 'ambiguous',
            normalizedPath,
            candidates: matches.map((match) => match.candidate.sourceFile),
        };
    }
    return undefined;
}
function resolveOrCadLogicalSchematicReference(candidates, referencingFile, reference, referencedViewName) {
    const normalizedReference = normalizeReference(referencingFile, reference);
    const grouped = groupedCandidates(candidates, referencingFile);
    const exact = resolutionFromMatches(grouped.filter((candidate) => candidate.stem === normalizedReference.stem), normalizedReference.path, 'exact');
    if (exact) {
        return exact;
    }
    if (normalizedReference.allowSuffixMatch) {
        const suffix = resolutionFromMatches(grouped.filter((candidate) => normalizedReference.stem.endsWith(candidate.stem)), normalizedReference.path, 'suffix');
        if (suffix) {
            return suffix;
        }
    }
    const referencedBasename = sigma_engine_shared_1.Files.basenamePath(normalizedReference.stem).toLowerCase();
    const basename = resolutionFromMatches(grouped.filter((candidate) => sigma_engine_shared_1.Files.basenamePath(candidate.stem).toLowerCase() === referencedBasename), normalizedReference.path, 'basename');
    if (basename) {
        return basename;
    }
    const normalizedViewName = referencedViewName?.trim().toLowerCase();
    if (normalizedViewName) {
        const view = resolutionFromMatches(grouped.filter((candidate) => candidate.candidate.schematicViewNames?.some((viewName) => viewName.trim().toLowerCase() === normalizedViewName)), normalizedReference.path, 'view');
        if (view) {
            return view;
        }
    }
    return {
        status: 'unresolved',
        reason: 'missing',
        normalizedPath: normalizedReference.path,
        candidates: [],
    };
}
//# sourceMappingURL=orcadLogicalSchematicReferenceResolver.js.map